import axios from 'axios';
import { applyAuthRequestInterceptor, applyEnvelopeInterceptor } from './axiosInterceptors';

/** API origin (scheme+host, no path). Empty for same-origin local dev. */
const API_ORIGIN = import.meta.env.VITE_API_BASE_URL ?? '';

/**
 * Session-authed axios instance for watcher-service.
 *
 * Routes through API Gateway at `/api/watcher-service/*` (rewrites to `/api/*`
 * on watcher-service:<port>). Gateway injects identity headers:
 *   - X-User-Id
 *   - X-Organization-Id
 * from the JWT session — no need to set them here.
 *
 * Session-expiry and the uniform envelope are handled by applyEnvelopeInterceptor.
 */
function createWatcherClient() {
  const client = axios.create({
    baseURL: `${API_ORIGIN}/api/watcher-service`,
    timeout: 30000,
    withCredentials: true,
    headers: { 'Content-Type': 'application/json' },
  });

  applyAuthRequestInterceptor(client);
  applyEnvelopeInterceptor(client);

  return client;
}

export const watcherServiceClient = createWatcherClient();
